import instance,{BASE_URL} from "../../services/api";
import fileDownload from "js-file-download";
import toast from "react-hot-toast";

const ReportApiViewController = () => {
//   const getErrorMessage = (error) => {
//   return (
//     error.response?.data?.detail ||   // Django REST Framework style
//     error.response?.data?.message ||  // custom backend message
//     error.response?.data?.error ||    // another fallback
//     error.message ||                  // Axios default
//     "Something went wrong!"
//   );
// };
  const getEmployeeForReport = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}report/employee/`
      );
      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      // console.log("Fetched attendance data:", response.data);
      dispatch({ type: "GET_EMPLOYEE_FOR_REPORT_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      //  const message = getErrorMessage(error);
      dispatch({
        type: "GET_EMPLOYEE_FOR_REPORT_FAILURE",
        payload: { error: error }
      });
      // toast.error(message);
    }
  };

  const generatePFECRReport = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });

    try {
      const response = await instance.post(
        `${BASE_URL}generate-pf-ecr/`,
        reqData,
        {
          responseType: "blob", // key to receiving zip
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      // Extract the filename from the response headers
      let filename = "";
      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition && contentDisposition.includes("filename=")) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      // ✅ Fallback if filename is not found (optional safety)
      if (!filename) {
        const fileType = response.data.type;
        const extension = fileType === "text/plain" ? ".txt" : ".zip";
        filename = `pf_ecr_report_${Date.now()}${extension}`;
      }

      // Trigger download
      fileDownload(response.data, filename);

      dispatch({ type: "GENRATE_PF_ECR_REPORT_SUCCESS" });
      toast.success("PF ECR report downloaded successfully");
      return response
    } catch (error) {
      let errorMsg = "Failed to generate PF ECR report";

      // Attempt to extract JSON message from blob error response
      if (error.response && error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          errorMsg = json.message || json.error || errorMsg;
        } catch (e) {
          console.warn("Failed to parse error blob:", e);
        }
      } else {
        errorMsg = error.response?.data?.message || error.message || errorMsg;
      }

      dispatch({
        type: "GENRATE_PF_ECR_REPORT_FAILURE",
        payload: { error: errorMsg }
      });
      // const message = getErrorMessage(error);
      toast.error(`Error: ${errorMsg}`);
      console.error("GENRATE_PF_ECR_REPORT_FAILURE:", error.response);
    } finally {
      dispatch({ type: "LOADING", payload: false });
      // toast.error(message);
    }
  };

  const genrateESICReport = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });

    try {
      const response = await instance.post(
        `${BASE_URL}generate-esic-report/`,
        reqData,
        {
          responseType: "blob", // important to get binary data
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      // Use month to name the file
      const monthName = reqData.month || "Attendance_Report";
      const filename = `ESIC_Report_${monthName}.xlsx`;

      // Download file
      fileDownload(response.data, filename);

      dispatch({ type: "GENRATE_ESIC_REPORT_SUCCESS" });
      toast.success("ESIC report downloaded successfully");
      return response
    } catch (error) {
      let errorMsg = "Failed to generate ESIC report";
      
      // Attempt to extract JSON message from blob error response
      if (error.response && error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          errorMsg = json.message || json.error || errorMsg;
        } catch (e) {
          console.warn("Failed to parse error blob:", e);
        }
      } else {
        errorMsg = error.response?.data?.message || error.message || errorMsg;
      }

      dispatch({
        type: "GENRATE_ESIC_REPORT_FAILURE",
        payload: { error: errorMsg }
      });
      toast.error(`Error: ${errorMsg}`);
      console.error("*****GENRATE_ESIC_REPORT_FAILURE:", errorMsg);
    } finally {
      dispatch({ type: "LOADING", payload: false });
    }
  };

  return {
    getEmployeeForReport,
    generatePFECRReport,
    genrateESICReport
  };
};

export default ReportApiViewController;
